import dayjs from 'dayjs';
import { LeaderboardDuration } from './types/leaderboard.js';
/// ADDRESSES AND ALIASES
// export const shortenAddress = (
//   address?: string,
//   aleo: boolean = false,
//   length: number = 7
// ) => {
//   if (!address) return '';
//   if (address.length < length * 2) return address;
//   return `${address.slice(
//     0,
//     length + (aleo ? 'aleo1'.length : 0)
//   )}...${address.slice(address.length - length, address.length)}`;
// };
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const shortenAddress = (address, aleo = true, length = 4, short = true) => {
    if (!address)
        return '';
    if (address.length < length)
        return address;
    if (short) {
        return `(...${address.slice(-length)})`;
    }
    if (address.length < length * 2)
        return address;
    return `${address.slice(0, length + (aleo ? 'aleo1'.length : 0))}...${address.slice(address.length - length, address.length)}`;
};
/// DATES
export const formattedDateTimeString = (unix, ms) => {
    return dayjs
        .unix(ms === true ? unix / 1000 : unix)
        .format('MM/DD/YYYY h:mm a');
};
export const formattedDateString = (unix, ms) => {
    return dayjs.unix(ms === true ? unix / 1000 : unix).format('MM/DD/YYYY');
};
export const formattedDateTimeStringMonthName = (unix, ms) => {
    return dayjs
        .unix(ms === true ? unix / 1000 : unix)
        .format('MMM DD, YYYY h:mm a');
};
export const formattedDateStringMonthName = (unix, ms) => {
    return dayjs.unix(ms === true ? unix / 1000 : unix).format('MMM DD, YYYY');
};
export function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ('0' + (byte & 0xff).toString(16)).slice(-2);
    }).join('');
}
const isToday = (someDate) => {
    const today = new Date();
    if (!someDate)
        return false;
    return (someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear());
};
/// ASSETS
export const USDFormatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
});
/// MISC
/// get combinations of size k from set
/// adapted from https://gist.github.com/axelpale/3118596
export const combinations = (set, k) => {
    var i, j, combs, head, tailcombs;
    // impossible to take e.g. sets of 5 elements from a set of 4
    if (k > set.length || k <= 0) {
        return [];
    }
    // k-sized set has only one k-sized subset
    if (k === set.length) {
        return [set];
    }
    // there are n 1-sized subsets in an n-sized set
    if (k == 1) {
        combs = [];
        for (i = 0; i < set.length; i++) {
            combs.push([set[i]]);
        }
        return combs;
    }
    // at this point, 1 < k < set.length
    combs = [];
    for (i = 0; i < set.length - k + 1; i++) {
        head = set.slice(i, i + 1);
        tailcombs = combinations(set.slice(i + 1), k - 1);
        for (j = 0; j < tailcombs.length; j++) {
            combs.push(head.concat(tailcombs[j]));
        }
    }
    return combs;
};
export const getErrorMessage = (error) => {
    if (error instanceof Error)
        return error.message;
    return String(error);
};
export const exponentialDelay = async (retries) => {
    /// exponential delay in ms
    const max = 500;
    const min = 2000;
    // adding some randomness to stagger the requests a bit more.
    const randomInt = Math.floor(Math.random() * (max - min + 1) + min);
    const delay = Math.pow(2, retries) * randomInt;
    await new Promise((resolve) => setTimeout(resolve, delay));
};
export const parseXForwardedFor = (ip) => {
    if (ip === undefined) {
        return '127.0.0.1';
    }
    else if (typeof ip === 'string') {
        return ip.split(',')[0];
    }
    else {
        return ip[0] ?? '127.0.0.1';
    }
};
export const nicknameRegex = /^[a-zA-Z0-9_ ]{0,15}$/;
export const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const getReversedEntryFunctions = (raffle) => {
    const reversedEntryFunctions = Object.fromEntries(Object.entries(raffle.entryFunctions).map(([key, value]) => [value, key]));
    return reversedEntryFunctions;
};
export const compareVersions = (version_1, version_2) => {
    const parts1 = version_1.split('.').map(Number);
    const parts2 = version_2.split('.').map(Number);
    // Compare each part from major to patch
    for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
        const num1 = parts1[i] || 0; // default to 0 if undefined
        const num2 = parts2[i] || 0; // default to 0 if undefined
        if (num1 > num2)
            return -1;
        if (num1 < num2)
            return 1;
    }
    // If all parts are equal
    return 0;
};
export const creditsAsset = {
    tokenId: '0field',
    name: 'Aleo Credits',
    symbol: 'ALEO',
    programId: 'credits.aleo',
    decimals: 6,
    supply: 1000000000,
    isMTSP: false,
    displayIfZero: true,
    recordName: 'credits',
    iconURL: 'https://i.imgur.com/93nm9CT.png',
    coinbaseSymbol: 'aleo',
    priority: 0,
};
export const raffleFees = {
    '1': 0.25,
    '2': 0.35,
    '3': 0.45,
    '4': 0.55,
    '5': 0.65,
    '6': 0.75,
    '7': 0.9,
    '8': 1.0,
    '9': 1.1,
    '10': 1.2,
    '11': 1.3,
    '12': 1.4,
    '13': 1.5,
    '14': 1.6,
};
// Helper function to check if the last request was made less than 2 hours ago
export function checkLastRequestTime(lastRequestTime, type) {
    if (!lastRequestTime)
        return;
    const now = new Date();
    const differenceInHours = (now.getTime() - lastRequestTime.getTime()) / (1000 * 60 * 60);
    if (differenceInHours < 4) {
        throw new Error('You must wait at least four hours between requests!', {
            cause: 'too_soon',
        });
    }
}
/**
 * Aleo uses funky serialization for its JSON objects. This function takes that funky representation
 * and makes it a valid json object
 * @param aleoString Invalid aleo json string
 * @returns A valid, JSON.parse-able string
 */
export const formatAleoString = (aleoString) => {
    const keyValueRegex = /([a-zA-Z0-9_]+)(\s*):(\s*)([a-zA-Z0-9_.]+)/g;
    const objectArrayRegex = /([a-zA-Z0-9_]+)(\s*):(\s*)(\{|\[)/g;
    const arrayElementRegex = /(\[|,)(\s*)([a-zA-Z0-9_.]+)/g;
    let replacedString = aleoString.replace(objectArrayRegex, (_, key, space1, space2, open) => {
        return `\\"${key}\\"${space1}:${space2}${open}`;
    });
    replacedString = replacedString.replace(keyValueRegex, (_, key, space1, space2, value) => {
        return `\\"${key}\\"${space1}:${space2}\\"${value}\\"`;
    });
    replacedString = replacedString.replace(arrayElementRegex, (_, separator, space, element) => {
        return `${separator}${space}\\"${element}\\"`;
    });
    const nestedMatch = replacedString.match(objectArrayRegex);
    if (nestedMatch) {
        for (const match of nestedMatch) {
            const open = match[match.length - 1];
            const close = open === '{' ? '}' : ']';
            const nestedStart = replacedString.indexOf(match) + match.length - 1;
            let nestedEnd = nestedStart;
            let balance = 1;
            while (balance > 0) {
                nestedEnd++;
                if (replacedString[nestedEnd] === open) {
                    balance++;
                }
                else if (replacedString[nestedEnd] === close) {
                    balance--;
                }
            }
            const nestedJson = replacedString.slice(nestedStart, nestedEnd + 1);
            const formattedNestedJson = formatAleoString(nestedJson);
            replacedString = replacedString.replace(nestedJson, formattedNestedJson);
        }
    }
    return replacedString;
};
export const getLeaderboardStartDate = (duration) => {
    const now = new Date();
    let startDate;
    switch (duration) {
        case LeaderboardDuration.Day:
            startDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            break;
        case LeaderboardDuration.Week:
            // Get the start of the week (Sunday)
            const day = now.getUTCDay();
            startDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - day));
            break;
        case LeaderboardDuration.Month:
            startDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth()));
            break;
        default:
            throw new Error('Invalid duration');
    }
    return startDate;
};
export const getLeaderboardEndDate = (duration) => {
    const startDate = getLeaderboardStartDate(duration);
    const endDate = new Date(startDate);
    switch (duration) {
        case LeaderboardDuration.Day:
            endDate.setUTCDate(endDate.getUTCDate() + 1);
            break;
        case LeaderboardDuration.Week:
            endDate.setUTCDate(endDate.getUTCDate() + 7);
            break;
        case LeaderboardDuration.Month:
            endDate.setUTCMonth(endDate.getUTCMonth() + 1);
            break;
        default:
            throw new Error('Invalid duration');
    }
    // Add 10 minutes buffer
    endDate.setUTCMinutes(endDate.getUTCMinutes() + 10);
    return endDate;
};
